import React from 'react';

interface Props {
    ikon: string;
    className?: string;
}

const Ikon = (props: Props) => {
    return <span className={`meld-skade-ikon ${props.className} ${props.ikon}`} />;
};

export default Ikon;
